import loadable from '@loadable/component';

/**
 * Code-split wrapper for SignupAction — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
const SignupAction = loadable(
    /* #__LOADABLE__ */
    () => import('./SignupAction'),
    {
        ssr: false,
    }
);

export default SignupAction;
